import React, { useEffect } from "react";
import styled from "styled-components";
import { Marginer } from "../../Components/Marginer";
import Logo from "../../Assets/Hnet.com-image.png"
import Backpanel from "../../Assets/flowers2.jpg"
import Fourthback from "../../Assets/fourthbackground.jpg"
import Thirdpanelpic from "../../Assets/ThirdpanelPic.png"
import {Facebook,Instagram,Twitter,Telegram,Linkedin} from "@styled-icons/boxicons-logos"
import {TelephoneFill} from "@styled-icons/bootstrap"
import {Link} from "react-scroll"
import { useNavigate } from "react-router-dom";
import axios from "axios";

const PageHolder = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
`;

const HeaderDiv = styled.div`
    width: 100%;
    height: 21vh;
    display: flex;
    flex-direction: column;
    background-color: #443C54;
    align-items: center;

    @media (max-width: 900px) {
        justify-content:center;
    }
`;

const Logoimg = styled.img`
    width: 190px;
    height: auto;
    margin-top: 1.8vw;

    @media (max-width: 900px) {
        margin-top: 5px;
    }

    &:hover{
        cursor:pointer;
    }

`;


const BottomLine = styled.div`
    width: 70vw;
    height: 1px;
    margin-top: 0.9vw;
    background-color: #ffffff6a;
    border-radius: 80%;
    box-shadow: 0px 2px 7px 2px #353535;

    @media (max-width: 900px) {
        width: 90vw;
        margin-top: 3vw;
    }

`;

const Linkholder = styled.div`
    width: 60vw;
    height: 3vh;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;

    @media (max-width: 900px) {
        width: 90vw;
    }

    @media (min-width: 900px) and (max-width: 1400px) {
        width: 70vw;
    }

`;


const SocialHolder = styled.div`
    width: 20vw;
    height: 3vh;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;



    @media (max-width: 600px) {
       
       width: 0vw;
       display: none;
    }

    @media (min-width: 600px) and (max-width: 900px) {
        
        width: 22vw;
    }

   

`;

const Facebooklink = styled(Facebook)`
  width: 1.2vw;
  color:${props => props.color};


  &:hover{
        cursor: pointer;
        color: #e2d186;
    }

    @media (max-width: 450px) {
       
       width: 3vw;
  }

  @media (min-width: 450px) and (max-width: 900px) {
      
       width: 2vw;
  }

  @media (min-width: 900px) and (max-width: 1300px) {
      
       width: 1.7vw;
  }

  @media (min-width: 1300px) and (max-width: 1700px) {
      
   width: 1.2vw;
  }

`;

const Instagramlink = styled(Instagram)`
  width: 1.2vw;
  color:${props => props.color};


  &:hover{
        cursor: pointer;
        color: #e2d186;
    }
    @media (max-width: 450px) {
       
       width: 3vw;
  }

  @media (min-width: 450px) and (max-width: 900px) {
      
       width: 2vw;
  }

  @media (min-width: 900px) and (max-width: 1300px) {
      
       width: 1.7vw;
  }

  @media (min-width: 1300px) and (max-width: 1700px) {
      
   width: 1.2vw;
  }
  
`;

const Twitterlink = styled(Twitter)`
  width: 1.2vw;
  color:${props => props.color};
  &:hover{
        cursor: pointer;
        color: #e2d186;
    }

    @media (max-width: 450px) {
       
       width: 3vw;
  }

  @media (min-width: 450px) and (max-width: 900px) {
      
       width: 2vw;
  }

  @media (min-width: 900px) and (max-width: 1300px) {
      
       width: 1.7vw;
  }

  @media (min-width: 1300px) and (max-width: 1700px) {
      
   width: 1.2vw;
  }

`;

const Telegramlink = styled(Telegram)`
  width: 1.2vw;
  color:${props => props.color};


  &:hover{
        cursor: pointer;
        color: #e2d186;
    }

    @media (max-width: 450px) {
       
       width: 3vw;
  }

  @media (min-width: 450px) and (max-width: 900px) {
      
       width: 2vw;
  }

  @media (min-width: 900px) and (max-width: 1300px) {
      
       width: 1.7vw;
  }

  @media (min-width: 1300px) and (max-width: 1700px) {
      
   width: 1.2vw;
  }

`;

const Linkedinlink = styled(Linkedin)`
  width: 1.2vw;
  color: ${props => props.color};

  &:hover{
        cursor: pointer;
        color: #e2d186;
    }

    @media (max-width: 450px) {
       
        width: 3vw;
   }

   @media (min-width: 450px) and (max-width: 900px) {
       
        width: 2vw;
   }

   @media (min-width: 900px) and (max-width: 1300px) {
       
        width: 1.7vw;
   }

   @media (min-width: 1300px) and (max-width: 1700px) {
       
    width: 1.2vw;
   }

    

`;

const Numbertext = styled.h3`
    font-size: 0.8vw;
    color: white;
    font-weight: normal;
    margin-top: 9px ;

    @media (max-width: 600px) {
       
        font-size: 1.8vw;
    }

    @media (min-width: 600px) and (max-width: 900px) {
        
        font-size: 1.6vw;
    }

    @media (min-width: 900px) and (max-width: 1300px) {
        
        font-size: 1.2vw;
    }

    @media (min-width: 1300px) and (max-width: 1700px) {
        
        font-size: 0.9vw;
    }

  
  
`;

const LinkButton = styled.button`
    width:7vw;
    height:1.5vw;
    background-color: #443C54 ;
    border:0px;
    color: white;
    font-size: 1.1vw;

    &:hover{
        cursor: pointer;
        color: #e2d186;
    }

    @media (max-width: 600px) {
        width: 19vw;
        font-size: 3.4vw;
        font-weight: bold;
    }

    @media (min-width: 600px) and (max-width: 900px) {
        width: 16vw;
        font-size: 2.4vw;
        font-weight: bold;
    }

    @media (min-width: 900px) and (max-width: 1300px) {
        width: 10vw;
        font-size: 1.7vw;
    }

    @media (min-width: 1300px) and (max-width: 1700px) {
        width: 9vw;
        font-size: 1.2vw;
    }

  
`;

const Mainpanel = styled.div`
  
  width:100%;
  height: 82vh;
  background-image: url(${Backpanel});
  display: flex;
  flex-direction: column;
  word-wrap: break-word;
  background-position: bottom -200px left -400px;
  @media (max-width: 600px) {
    background-position: bottom -200px left -520px;
    }
`;

const MainpanelCover = styled.div`
  width: 100%;
  height: 100%;
  background-color: #00000061;
  display: flex;
  flex-direction: column;
  align-items:center;
`;

const SecPanel = styled.div`
  
  width:100%;
  height: 30vh;
  background-color: #DEDAE5;
  display: flex;
  flex-direction: column;
  justify-content:center ;
  align-items: center ;
`;

const ThirdPanel = styled.div`
  
  width:100%;
  height: 70vh;
  background-color: #443C54;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const FourthPanel = styled.div`
  width:100%;
  min-height: 45vh;
  background-image: url(${Fourthback});
  display: flex;
  flex-direction: column;
  align-items: center;
  background-size: cover;
`;

const FourthPanelCover = styled.div`
  width:100%;
  min-height: 45vh;
  background-color: #1d1d1d6d;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const FifthPanel = styled.div`
  width:100%;
  height: 50vh;
  background-color: #5C5172;
  display: flex;
  flex-direction: column;
  align-items: center ;
  justify-content: center ;
`;

const FifthPanelinner = styled.div`
  width: 90vw;
  height: 35vh;
  background-color: white;
  display: flex;
  flex-direction: column;
  align-items: center ;
  justify-content: center ;
`;

const MainHeader = styled.h1`
    font-size: 3.7vw;
    color:white;
    margin-top:0;
    margin-bottom:0;
    font-family: Lateef ;
    font-weight: normal ;
    text-shadow: 2px 7px 3px #0808086c;

    @media (max-width: 700px) {
        font-size: 9vw;
        font-weight: Bold ;
    }

    @media (min-width: 700px) and (max-width: 900px) {
        font-size: 7vw;
        font-weight: Bold ;
    }

    @media (min-width: 900px) and (max-width: 1300px) {
        font-size: 5vw;
        font-weight: Bold ;
    }

`;


const SecText = styled.h1`
    font-size: 2.2vw;
    color:white;
    margin:50px;
    margin-top:0;
    margin-bottom:0;

    font-family: Lateef ;
    font-weight: normal ;

    @media (max-width: 700px) {
        font-size: 5vw;
        font-weight: Bold ;
    }

    @media (min-width: 700px) and (max-width: 900px) {
        font-size: 3.2vw;
        font-weight: Bold ;
    }

    @media (min-width: 900px) and (max-width: 1300px) {
        font-size: 2.8vw;
        font-weight: Bold ;
    }
`;


const ThirdText = styled.h1`
    font-size: 1.6vw;
    color:white;
    margin:50px;
    margin-top:3vh;
    margin-bottom:0;
    font-family: Lateef ;
    font-weight: normal ;
    text-align:center;

    @media (max-width: 700px) {
        font-size: 4vw;
        font-weight: Bold ;
    }

    @media (min-width: 700px) and (max-width: 900px) {
        font-size: 3.2vw;
        font-weight: Bold ;
    }

    @media (min-width: 900px) and (max-width: 1300px) {
        font-size: 2.4vw;
        font-weight: Bold ;
    }

  
`;

const SecmainText = styled.h1`
    font-size: 2vw;
    color: #443C54;
    margin-top:0;
    margin-bottom:0;
    font-weight: normal ;

    @media (max-width: 700px) {
        font-size: 3.5vw;
        font-weight: Bold ;
    }

    @media (min-width: 700px) and (max-width: 900px) {
        font-size: 3.2vw;
        font-weight: Bold ;
    }

    @media (min-width: 900px) and (max-width: 1300px) {
        font-size: 2.9vw;
        font-weight: Bold ;
    }

`;

const SecmainTextMini = styled.h1`
    font-size: 1.3vw;
    color: #443C54;
    margin-top:4vh;
    margin-bottom:0;
    font-weight: bolder ;
    

  @media (max-width: 700px) {
        font-size: 3.5vw;
        font-weight: Bold ;
    }

    @media (min-width: 700px) and (max-width: 900px) {
        font-size: 2.7vw;
        font-weight: Bold ;
    }

    @media (min-width: 900px) and (max-width: 1300px) {
        font-size: 1.7vw;
        font-weight: Bold ;
    }

`;

const ThirdPanelHolder = styled.div`
  display  : flex ;
  flex-direction: row ;
  align-items: center ;
`;

const ImageVertical = styled.div`
  width: 25vw;
  height: 53vh;
  background-image: url(${Thirdpanelpic}) ;
  background-size: cover;
  display: flex ;
  flex-direction: column;

  @media (min-width: 1000px) and (max-width: 1600px) {
    width: 35vw;
  }

  @media (max-width: 1000px) {
    width: 0vw;
  }

`;

const ImageVerticalCover = styled.div`
  width: 100%;
  height: 100%;
  background-color: #ffffff17 ;

  &:hover{
        cursor: pointer;
        background-color: #2222226c;
    }
`;


const WhiteContainer = styled.div`
 width: 25vw;
 height: 43vh;
 background-color: white ;
 display: flex ;
 flex-direction: column;
 align-items: center;

 @media (min-width: 1000px) and (max-width: 1600px) {
    width: 35vw;
  }

 @media (max-width: 1000px) {
    width: 80vw;
  }


`;

const WhitetextFourthTitle = styled.h1`
    font-size: 3.5vw;
    color: white;
    margin-top:0;
    margin-bottom:0;
    margin-left: 40vw;
    font-family: Lateef ;
    font-weight: bolder;

    @media (max-width: 900px) {
        font-size: 6vw;
    }

    @media (max-width: 700px) {
        font-size: 8vw;
    }

`;

const WhitetextFourth = styled.h1`
    font-size: 1.4vw;
    color: white;
    margin-top:0;
    margin-bottom:30px;
    margin-left: 20px;
    margin-right: 20px;
    font-family: Lateef ;
    font-weight: normal;
    direction: rtl;
    text-align: center;
    width: 50%;
      
    @media (max-width: 500px) {
        font-size: 3.9vw;
        width: 70%;
    }

    @media (min-width: 500px) and (max-width: 700px) {
        font-size: 3.3vw;
        width: 70%;
    }

    @media (min-width: 700px) and (max-width: 900px) {
        font-size: 2.5vw;
        width: 60%;
    }

    @media (min-width: 900px) and (max-width: 1300px) {
        font-size: 2.3vw;
        width: 60%;
    }

  

`;

const PurpleTextThirdTitle = styled.a`

    font-size: 3vh;
    color: #443C54;
    margin-top:0;
    margin-bottom:0;
    font-weight: normal;

    &:hover{
        cursor: pointer;
        color: #6d6a726c;
    }
`;

const PurpleTextThird = styled.h1`

    font-size: 2vh;
    color: #443C54;
    margin-top:0;
    margin-bottom:0;
    font-weight: normal;

    
`;

const PurpleTextThird2 = styled.h1`
    font-size: 2vh;
    color: #443C54;
    margin-top:0;
    margin-bottom:0;
    font-weight: normal;
`;

const YellowTextFifth = styled.h1`
    font-size: 5vh;
    color: #443C54;
    margin-top:0;
    margin-bottom:0;
    font-weight: Bolder;
`;

const YellowTextFifthMini = styled.h1`
    font-size: 2vh;
    color: #443C54;
    margin-top:0;
    margin-bottom:0;
    font-weight: normal;
`;

const Purpleline = styled.div`
    width: 70%;
    height: 1px ;
    background-color:#443C54 ;
`;

const PurpleButtonThird = styled.button`
    width: 15vh;
    height: 4vh;
    font-size: 2.3vh;
    color: white;
    background-color: #443C54;
    border: 0px;

    &:hover{
        cursor: pointer;
        background-color: #6d6a72b0;
    }
`;


const PurpleButtonFifth = styled.button`
    width: 15vh;
    height: 4vh;
    font-size: 2.3vh;
    color: white;
    background-color: #443C54;
    border: 0px;
    border-radius: 20px;

    &:hover{
        cursor: pointer;
        background-color: #6d6a72b0;
    }

    
`;

const TelephoneSign = styled(TelephoneFill)`
    width:1.7vh;
    color: white;
    margin-bottom: 3px ;
`;

const MiniCopyrightHolder = styled.div`
    height: 3vh ;
    width:100%;
    background-color: #443C54 ;
    display:flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
`;

const MiniCopyrightText = styled.h1`

    font-size:1.5vh;
    color: white;
    margin-top:0;
    margin-bottom:0;
    font-weight: normal;
`;

export function MainPage(props){
    const navigate = useNavigate();

    useEffect(() => {
        axios.get('https://salwa-amer-backend.onrender.com/get_blogs')
        .then(res => {
            const blogslist = res.data;
        })
    },[])

    return(
        <PageHolder>
            <HeaderDiv>
            <Logoimg onClick={()=>{navigate("/")}} src = {Logo} ></Logoimg>
            <BottomLine/>
            <Marginer height={2} width ={1}></Marginer>
            <Linkholder>
            <SocialHolder>
            <Numbertext> +966561958908 </Numbertext>
            </SocialHolder>
            <LinkButton> <Link to={"About"} spy={true} smooth={true}>من أنا</Link> </LinkButton>
            <LinkButton> <Link to={"Contact"} spy={true} smooth={true}>تواصل معي</Link> </LinkButton>
            {/* <LinkButton>دورات</LinkButton> */}
            <LinkButton onClick={()=>navigate("/blogs")}>منشورات</LinkButton>
            <LinkButton><Link to={"Service"} spy={true} smooth={true}>استشارات</Link></LinkButton>
            <LinkButton>الرئيسية</LinkButton>
            <SocialHolder>
            <a href={"https://www.facebook.com/salwaamer2020"}  target={"blank"}><Facebooklink color={"white"}></Facebooklink></a>
            <Marginer height={0} width ={0.5}></Marginer>
            <a href={"https://www.instagram.com/sa.lwa4494/"}  target={"blank"}><Instagramlink color={"white"}></Instagramlink></a>
            <Marginer height={0} width ={0.5}></Marginer>
            <a href={"https://twitter.com/Hadfona_wahd"}  target={"blank"}><Twitterlink color={"white"}></Twitterlink></a>
            <Marginer height={0} width ={0.5}></Marginer>
            <a href={"https://t.me/alacademya"}  target={"blank"}><Telegramlink color={"white"}></Telegramlink></a>
            <Marginer height={0} width ={0.5}></Marginer>
            <a href={"https://www.linkedin.com/in/salwa-amer-71629b156/"}  target={"blank"}><Linkedinlink color={"white"}></Linkedinlink></a>
            <Marginer height={0} width ={2}></Marginer>
            </SocialHolder>
            </Linkholder>
            </HeaderDiv>
            <Mainpanel>
            <MainpanelCover>
                <Marginer height={5} width ={1}></Marginer>
                <MainHeader>سلوى عامر</MainHeader>
                <MainHeader>استشارات حياتية</MainHeader>
                <Marginer height={10} width ={1}></Marginer>
                <SecText>معا للوصول إلى الراحة النفسية</SecText>
                <ThirdText>لكل شخص طريقته في الكتابة غير كتابة الحرف ولكل منا طريقته في الكتابة على صفحة العالم </ThirdText>
                <ThirdText>لأن في الكلام قوة وفي العلم قوة وفي العمل قوة وتغيير للعالم وللحضارة والانسان </ThirdText>
                <ThirdText>فلتبحث عن طريقتك</ThirdText>
                <ThirdText>نساعدك هنا للوصول الى غايتك</ThirdText>
                <ThirdText>💜 فانضم الى عالمنا الجميل</ThirdText>
            </MainpanelCover>
            </Mainpanel>
            <SecPanel>
                <SecmainText>"السعادة ليست غياب المشاكل بل القدرة على التعامل معها"</SecmainText>
                <SecmainTextMini>هيلين كيلر</SecmainTextMini>
            </SecPanel>
            <ThirdPanel id={"Service"}>
            <Marginer height={10} width ={1}></Marginer>
            <ThirdPanelHolder>
            <ImageVertical>
            <ImageVerticalCover></ImageVerticalCover>
            </ImageVertical>
            <WhiteContainer>
                <Marginer height={5} width ={1}></Marginer>
                <PurpleTextThird>Family consultations - Behavior modification</PurpleTextThird>
                <PurpleTextThird> - Managing emotions and thought</PurpleTextThird>
                <Marginer height={2} width ={1}></Marginer>
                <PurpleTextThirdTitle>استشارة حياتية</PurpleTextThirdTitle>
                <Marginer height={2} width ={1}></Marginer>
                <PurpleTextThird>( تربوية أسرية)</PurpleTextThird>
                <Marginer height={2} width ={1}></Marginer>
                <Purpleline></Purpleline>
                <Marginer height={3} width ={1}></Marginer>
                <PurpleTextThird2>ساعة واحدة</PurpleTextThird2>
                <Marginer height={1} width ={1}></Marginer>
                <PurpleTextThird>التواصل على الواتسآب</PurpleTextThird>
                <Marginer height={3} width ={1}></Marginer>
                <form action="https://wa.me/966561958908" target="blank">
                <PurpleButtonThird >احجز استشارة</PurpleButtonThird>
                </form>
            </WhiteContainer>
            </ThirdPanelHolder>
            </ThirdPanel>
            <FourthPanel id="About">
                <FourthPanelCover>
                <Marginer height={5} width ={1}></Marginer>
                <WhitetextFourthTitle>من أنا؟</WhitetextFourthTitle>
                <Marginer height={3} width ={1}></Marginer>
                <WhitetextFourth>▪ دكتوراه علم نفس ارشادي وتربوي مهنية</WhitetextFourth>
                <WhitetextFourth>▪ عضو اتحاد المعالجيين النفسيين العرب</WhitetextFourth>
                <WhitetextFourth>▪ مدربة معتمدة من البورد الامريكي والمؤسسة العامة للتدريب المهني السعودي </WhitetextFourth>
                <WhitetextFourth>▪  تلقيت العديد من التدريبات على : </WhitetextFourth>
                <WhitetextFourth>▪ العلاج المعرفي السلوكى CBT  من معهد ارون بيك Beck Institute</WhitetextFourth>
                <WhitetextFourth>▪ مؤسس العلاج المعرفي السلوكي Cognitive behavioral therapy </WhitetextFourth>
                <WhitetextFourth>▪ العلاج الجدلى السلوكى DBT المعتمد من Alexandria Institute of psychotherapy (A.I.P) </WhitetextFourth>
                <WhitetextFourth>▪ العلاج بالقبول والالتزام  ACT  المعتمد من Arab Institute of Mental Health</WhitetextFourth>
                <Marginer height={6} width ={1}></Marginer>
                </FourthPanelCover>
            </FourthPanel>
            <FifthPanel id={"Contact"}>
                <FifthPanelinner>
                <YellowTextFifth>تواصل معي</YellowTextFifth>
                <Marginer height={2} width ={1}></Marginer>
                <YellowTextFifthMini>salwaamer61@yahoo.com</YellowTextFifthMini>
                <Marginer height={2} width ={1}></Marginer>
                <YellowTextFifthMini>+966561958908</YellowTextFifthMini>
                <Marginer height={2} width ={1}></Marginer>
                <SocialHolder>
                <a href={"https://www.facebook.com/salwaamer2020"}  target={"blank"}><Facebooklink color={"black"}></Facebooklink></a>
                <Marginer height={0} width ={0.5}></Marginer>
                <a href={"https://www.instagram.com/sa.lwa4494/"}  target={"blank"}><Instagramlink color={"black"}></Instagramlink></a>
                <Marginer height={0} width ={0.5}></Marginer>
                <a href={"https://twitter.com/Hadfona_wahd"}  target={"blank"}><Twitterlink color={"black"}></Twitterlink></a>
                <Marginer height={0} width ={0.5}></Marginer>
                <a href={"https://t.me/alacademya"}  target={"blank"}><Telegramlink color={"black"}></Telegramlink></a>
                <Marginer height={0} width ={0.5}></Marginer>
                <a href={"https://www.linkedin.com/in/salwa-amer-71629b156/"}  target={"blank"}><Linkedinlink color={"black"}></Linkedinlink></a>
                </SocialHolder>
                <Marginer height={2} width ={0.5}></Marginer>
                <form action="tel:+966561958908">
                <PurpleButtonFifth type="submit"> <TelephoneSign></TelephoneSign>  اتصل الأن</PurpleButtonFifth>
                </form>
                </FifthPanelinner>
               
            </FifthPanel>
            
            <MiniCopyrightHolder>
            <MiniCopyrightText>©2022 by Salwa Amer.</MiniCopyrightText>
            <SocialHolder>
            <a href={"https://www.facebook.com/salwaamer2020"}  target={"blank"}><Facebooklink color={"white"}></Facebooklink></a>
            <Marginer height={0} width ={0.5}></Marginer>
            <a href={"https://www.instagram.com/sa.lwa4494/"}  target={"blank"}><Instagramlink color={"white"}></Instagramlink></a>
            <Marginer height={0} width ={0.5}></Marginer>
            <a href={"https://twitter.com/Hadfona_wahd"}  target={"blank"}><Twitterlink color={"white"}></Twitterlink></a>
            <Marginer height={0} width ={0.5}></Marginer>
            <a href={"https://t.me/alacademya"}  target={"blank"}><Telegramlink color={"white"}></Telegramlink></a>
            <Marginer height={0} width ={0.5}></Marginer>
            <a href={"https://www.linkedin.com/in/salwa-amer-71629b156/"}  target={"blank"}><Linkedinlink color={"white"}></Linkedinlink></a>
            </SocialHolder>
            </MiniCopyrightHolder>
            
        </PageHolder>
    );
}